module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.fa2772327f55d8198301.woff";


//////////////////
// WEBPACK FOOTER
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/assets/fonts/glyphicons-halflings-regular.woff
// module id = ../../../../../src/assets/fonts/glyphicons-halflings-regular.woff
// module chunks = styles